import "@/App.css";
import "@/index.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import PrivacyPage from "./pages/PrivacyPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/iscrizione-confermata" element={<ConfirmationPage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/iscrizioni" element={<AdminDashboard />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
